var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons System"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#C6DBFB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3516 15.2016C12.1499 15.202 11.9502 15.1625 11.7638 15.0854C11.5774 15.0083 11.4081 14.8951 11.2656 14.7523L7.2002 10.6861L8.28625 9.6001L12.3516 13.6655L16.417 9.6001L17.5031 10.6861L13.4377 14.7515C13.2953 14.8944 13.126 15.0078 12.9396 15.085C12.7532 15.1622 12.5534 15.2019 12.3516 15.2016Z",
    fill: "#1671B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCircle);
export default __webpack_public_path__ + "static/media/arrowDownCircle.b0e6eeb64a1ef1eeb6458e82026f733d.svg";
export { ForwardRef as ReactComponent };